module.exports = __webpack_public_path__ + "img/markqueue-kynorelle.26f91629.webp";